import { Component } from '@angular/core';

@Component({
  selector: 'app-file-text-icon',
  imports: [],
  templateUrl: './file-text-icon.html',
  styleUrl: './file-text-icon.scss',
})
export class FileTextIcon {

}
